// extracted by mini-css-extract-plugin
module.exports = {"NavBrand":"NavBrand_NavBrand__1zsos"};